// Validación de QRs (empresa dueña o staff). Contrato: docs/CONTRATO-API-FASE2.md, §10 y §11.
import { empresaFetch } from './empresaApi';
import { staffFetch } from './staffApi';

// `mode` es 'empresa' (token de empresa) o 'staff' (token `staff-token`).
// staffFetch lanza StaffSessionError si la sesión ya no es válida.
const fetcherFor = (mode) => (mode === 'staff' ? staffFetch : empresaFetch);

export const getReservationInfo = async (mode, reservationId) => {
  const data = await fetcherFor(mode)(`/api/qr/info/${encodeURIComponent(reservationId)}`);
  return data.reservation;
};

// action: 'validate' | 'reject' ('reject' solo lo acepta el backend para la empresa dueña).
export const sendQrAction = async (mode, qrCode, action) => {
  const data = await fetcherFor(mode)('/api/qr/validate', {
    method: 'POST',
    body: { qrCode, action },
  });
  return data;
};
